import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { init, isHosted } from "./platform/telegram";
import App from "./App";
import "./styles/base.css";

// Must run before first paint: it sets data-scheme and publishes the viewport
// custom properties that base.css sizes the canvas from.
init();

// Host marker for CSS: the browser build wears iOS chrome (bottom tab bar,
// floating Home bar, immersive Learn) that the Telegram build must never get.
document.documentElement.dataset.host = isHosted ? "tg" : "web";

const container = document.getElementById("root");
if (!container) throw new Error("#root missing");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
